// @ts-nocheck
import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import {history} from "./_helpers"
import Login from './components/login';
import CreateProfile from './components/createprofile';
import Case from './components/case';
import Dashboard from './components/dashboard';
import Assign from './components/assign';
import CaseManagement from './components/casemanagement';
import MentorCase from "./components/mentorcase";
import ForgotPassword from "./components/forgotpass";
import $ from "jquery";
import Users from './components/users';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    localStorage.getItem('token')
      ? <Component {...props} />
      : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
  )} />
)

$("input[type=number]").on("keydown", function(e) {
  var invalidChars = ["-", "+", "e"]; //include "." if you only want integers
  if (invalidChars.includes(e.key)) {
      e.preventDefault();
  }
});

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
    }
  }

  

  render() {
    return (
          <React.Fragment>
            <ToastContainer />
            <BrowserRouter history={history}>
              <Switch>  
                <Route exact path="/" render={props => <Login {...props} />} />
                <Route exact path="/forgotpassword" render={props => <ForgotPassword {...props} />} />
                <Route exact path="/login" component={Login} />
                <PrivateRoute exact path="/dashboard" component={Dashboard}/>
                <PrivateRoute exact path="/profile" component={CreateProfile} />
                <PrivateRoute exact path="/caselog" component={Case}/>
                <PrivateRoute exact path="/assign" component={Assign}/>
                <PrivateRoute exact path="/case" component={CaseManagement}/>
                <PrivateRoute exact path="/mentorcase" component={MentorCase}/>
                <PrivateRoute exact path="/users" component={Users}/>
              </Switch>
            </BrowserRouter>
          </React.Fragment>
    );
  }
}



export default App;

